import { type FC } from 'react';
import cx from 'classnames';

// @ts-expect-error BookmarkEmpty does'nt have type definition
import { IconBookmarkEmpty } from 'src/assets/icons/BookmarkEmpty';
// @ts-expect-error JS component without types
import { IconBookmarkFilled } from 'src/assets/icons/BookmarkFilled';
// @ts-expect-error JS component without types
import { AnnotationRating } from 'src/components/AnnotationRating';
import { CustomIconButton } from 'src/components/CustomIconButton';
import { CUSTOM_TOOLTIP_SIZE, CustomTooltip } from 'src/components/CustomTooltip';
import { CustomTypography } from 'src/components/CustomTypography';
import type { TextAnnotation } from 'src/data/annotation/types';
import type { Callback } from 'src/lib/types';

import styles from './styles.module.scss';

interface Props {
  classes?: Record<string, string>;
  talkingPoint: TextAnnotation;
  onSave: Callback<TextAnnotation>;
  isSaved: boolean;
  isSaving?: boolean;
  hideBorder?: boolean;
}

export const TalkingPointItem: FC<Props> = ({
  talkingPoint,
  onSave,
  isSaved,
  isSaving,
  classes,
  hideBorder,
}) => {
  const rating = Math.min(Math.max(Math.round(talkingPoint.score), 0), 3);

  return (
    <div
      className={cx(styles.row, { [styles.hideBorder]: hideBorder })}
      data-testid="talkingPointItem"
    >
      <CustomTypography className={cx(styles.name, classes?.name)}>
        {talkingPoint.name}
      </CustomTypography>

      <CustomTooltip title="High performing talking point">
        <AnnotationRating rating={rating} />
      </CustomTooltip>

      <CustomTooltip
        title="Save"
        placement="top"
        size={CUSTOM_TOOLTIP_SIZE.small}
      >
        <CustomIconButton
          className={styles.saveButton}
          onClick={() => onSave(talkingPoint)}
          disabled={isSaved || isSaving}
          data-testid="saveResultButton"
        >
          {isSaved ? (
            <IconBookmarkFilled className={styles.saveIcon} />
          ) : (
            <IconBookmarkEmpty className={styles.saveIcon} />
          )}
        </CustomIconButton>
      </CustomTooltip>
    </div>
  );
};
